import React, { useState } from "react";

// chakra ui
import {
  Box,
  Checkbox,
  Flex,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
} from "@chakra-ui/react";

// common component
import { trackEvent } from "dapp-sdk-v2";

const buyURL = "https://purchase.banxa.com/?coinType=HBAR";

function BuyHbar() {
  const [agreeCheckbox, setAgreeCheckbox] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const redirectToWebsite = () => {
    window.open(buyURL, "_blank");
    onClose();
  };

  const handleClose = () => {
    setAgreeCheckbox(false);
    onClose();
  };

  const body = (
    <Flex alignItems="center" flexDirection="column" mb="20px">
      <Text
        textAlign="center"
        fontSize="16px"
        fontWeight="400"
        color="textSecondary"
        px="44px"
        m="0"
      >
        You are being directed to a third-party platform. Please be aware that
        the new platform may have risks and terms different from those of
        Stader. Stader does not have the ability to verify the platform or
        ascertain the risks associated with it. Users are advised to proceed at
        their own risk and assess the security, and terms of service of the new
        platform independently before transacting
      </Text>
      <Box py="1.8rem" marginBottom="0.5rem" borderRadius="0.5rem">
        <Checkbox
          checked={agreeCheckbox}
          as="span"
          border="2px"
          borderRadius="4px"
          borderColor="primary"
          mt="2px"
          onChange={(e) => {
            setAgreeCheckbox(e.target.checked);
          }}
        />

        <Text
          fontSize="12px"
          ml="8px"
          as="span"
          fontWeight="400"
          color="textSecondary"
        >
          I understand the risk and wish to proceed
        </Text>
      </Box>

      <Button
        onClick={() => {
          redirectToWebsite();
        }}
        disabled={!agreeCheckbox}
        w="128px"
        h="52px"
        mb="20px"
      >
        <Text py=".5rem" fontSize="16px">
          Ok
        </Text>
      </Button>
    </Flex>
  );

  return (
    <Box pl="16px">
      <Button
        border="1px"
        borderColor="primary"
        color="primary"
        bg="backgroundSecondary"
        _hover={{}}
        _dark={{
          color: "white",
          borderColor: "white",
        }}
        h="56px"
        onClick={() => {
          if (agreeCheckbox) {
            trackEvent("Buy_token");
            redirectToWebsite();
          } else {
            setAgreeCheckbox(false);
            onOpen();
          }
        }}
      >
        <Text px="16px">Buy HBAR</Text>
      </Button>

      <Modal isOpen={isOpen} onClose={handleClose} isCentered>
        <ModalOverlay />
        <ModalContent maxW="720px" bg="backgroundSecondary">
          <ModalHeader
            textAlign="center"
            mt="50px"
            mb="24px"
            fontSize="32px"
            fontWeight="700"
          >
            Disclaimer
          </ModalHeader>
          <ModalCloseButton onClick={handleClose} mt="54px" mr="44px" />
          <ModalBody m="0" p="0">
            {body}
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
}

export default BuyHbar;
